import React from "react";
import "../styles/SignIn.css";

const SelectMfaMethod = ({ email, phone, onSelect, loading = false }) => {
  const enableWhatsapp = false;
  return (
    <div className="signin-container">
      <div className="signin-card">
        <h2>Escolha como deseja receber o código</h2>

        <p className="signin-supporting-text">
          Selecione uma das opções abaixo para continuar o login.
        </p>

        <button
          className="mfa-button"
          type="button"
          onClick={() => onSelect("EMAIL")}
          disabled={loading}
        >
          Receber por e-mail{email ? ` (${email})` : ""}
        </button>

        <button
          className="mfa-button"
          type="button"
          onClick={() => onSelect("SMS")}
          disabled={loading}
        >
          Receber por SMS{phone ? ` (${phone})` : ""}
        </button>

        {enableWhatsapp && (
          <button
            className="mfa-button"
            type="button"
            onClick={() => onSelect("WHATSAPP")}
            disabled={loading}
          >
            WhatsApp
          </button>
        )}
      </div>
    </div>
  );
};

export default SelectMfaMethod;
